export enum ControlType {
  Text = 'Text',
  Integer = 'Integer',
  DropDown = 'DropDown',
  AccountDropDown = 'AccountDropDown',
  Date = 'Date',
  DateRange = 'DateRange',
  CalendarMonthYear = 'CalendarMonthYear',
  Comparison = 'Comparison',
  ValuesWithIDDropDown = 'ValuesWithIDDropDown',
  MultiDropDown = 'MultiDropDown',
}
